require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./psychologues-pour-tudiantsdoctorants-1-9-3.json") })
        }
      }, "path---psychologues-pour-tudiantsdoctorants-1-9-3");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---psychologues-pour-tudiantsdoctorants-1-9-3!./.cache/json/psychologues-pour-tudiantsdoctorants-1-9-3.json
// module id = 543
// module chunks = 231608221292675